if (!customElements.get('sds-product-launch-preview')) {
  class SdsProductLaunchPreview extends HTMLElement {
    connectedCallback() {
      this.launchTime = Number(this.dataset.launchTimestamp) * 1000;

      if (!Number.isFinite(this.launchTime)) return;

      this.localizeDate();
      this.scheduleRefresh();
    }

    disconnectedCallback() {
      window.clearTimeout(this.refreshTimer);
    }

    localizeDate() {
      const dateElement = this.querySelector('[data-launch-date]');
      if (!dateElement) return;

      try {
        const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
          timeZone: this.dataset.timeZone || 'Europe/Zurich',
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZoneName: 'short'
        });

        dateElement.textContent = formatter.format(new Date(this.launchTime));
      } catch (error) {
        // Keep the server-rendered numeric date when Intl formatting is unavailable.
      }
    }

    scheduleRefresh() {
      const remaining = this.launchTime - Date.now();

      if (remaining <= 0) {
        this.refreshProduct();
        return;
      }

      const maximumTimeout = 2147483647;
      this.refreshTimer = window.setTimeout(
        () => this.scheduleRefresh(),
        Math.min(remaining + 1000, maximumTimeout)
      );
    }

    refreshProduct() {
      const refreshKey = `sds-launch-refresh:${this.launchTime}`;

      try {
        const lastRefresh = Number(window.sessionStorage.getItem(refreshKey) || 0);
        if (Date.now() - lastRefresh < 60000) return;
        window.sessionStorage.setItem(refreshKey, String(Date.now()));
      } catch (error) {
        // Continue when storage is unavailable.
      }

      const url = new URL(window.location.href);
      url.searchParams.set('_sds_launch', String(Math.floor(this.launchTime / 1000)));
      window.location.replace(url.toString());
    }
  }

  customElements.define('sds-product-launch-preview', SdsProductLaunchPreview);
}
